import React, { useState, useRef, useEffect } from 'react';
import { requester } from "App";
import { CButton, CFormInput, CInputGroup, CInputGroupText } from '@coreui/react';
import style from "./VendorInquireList.module.css";

function VendorInquireList() {
    const [inquireList, setInquireList] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [selectedCategory, setSelectedCategory] = useState("deviceDefect");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const inputs = useRef({});

    // 날짜 포맷팅 함수 추가
    const formatDate = (dateString) => {
        return dateString.split('T')[0];
    };

    const categoryList = [
        { name: "deviceDefect", label: "기기불량" },
        { name: "inventoryInquiry", label: "재고문의" },
        { name: "etc", label: "기타" },
    ];

    const filteredList = inquireList.filter((data) => data.category === selectedCategory);
    const totalPages = Math.ceil(filteredList.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const displayedList = filteredList.slice(startIndex, startIndex + itemsPerPage);

    // 행 클릭 시 상세 정보 토글
    const toggleRowDetails = (id) => {
        setShowDetails((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleCategory = (categoryName) => {
        if (categoryName === selectedCategory)
            return
        else {
            setSelectedCategory(categoryName)
            setCurrentPage(1)
        }
    }

    const validAnswer = (id) => {
        const answer = inputs.current[id]?.value?.trim();

        if (!answer) {
            return false;
        }

        return {
            id,
            answer,
        };
    };

    const answerInquiry = (id) => {
        const validData = validAnswer(id);
        if (!validData) {
            return;
        }

        const data = {
            id,
            answer: inputs.current[id].value,
        };

        requester.inquireAnswer(data, () => {
            requester.InquireList((result) => {
                setInquireList(result.data);
                // 답변 후 해당 문의의 details를 닫음
                setShowDetails((prev) => ({
                    ...prev,
                    [id]: false
                }));
            });
        });
    };

    // 페이지네이션 처리 함수
    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    // 페이지 번호 배열 생성
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 5; // 한 번에 보여줄 최대 페이지 번호 수
        
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = startPage + maxPagesToShow - 1;
        
        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }
        
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        
        return pageNumbers;
    };

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.InquireList((result) => {
                setInquireList(result.data);
            });
        }
    }, [isMounted]);

    return (
        <div className={style.container}>
            <div className={style.flexGrid}>
                <div className={`${style.flexBox} ${style.fullWidth}`}>
                    <div className={style.card}>
                        <div className={style.section}>
                            <div className={style.sectionTitle}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span style={{width: "300px"}}>점주 문의 리스트</span>
                                    <div className={style.categoryBtnGroup}>
                                        {categoryList.map((c) => (
                                            <CButton
                                                key={c.name}
                                                onClick={() => handleCategory(c.name)}
                                                color={c.name === selectedCategory ? "primary" : "secondary"}
                                                
                                            >
                                                {c.label}
                                            </CButton>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={style.sectionContent}>
                                <div className={style.inquiryList}>
                                    <div className={style.inquiryHeader}>
                                        <p>답변상태</p>
                                        <p>제목</p>
                                        <p>작성자</p>
                                        <p>작성일</p>
                                    </div>
                                    {displayedList.length > 0 ? (
                                        displayedList.map((data) => (
                                            <div
                                                className={style.inquiryBox}
                                                key={data.id}
                                                onClick={() => toggleRowDetails(data.id)}
                                            >
                                                <p>
                                                    {data.inquireType === "Complete" ? (
                                                        <span className={style.complete}>답변완료</span>
                                                    ) : (
                                                        <span>답변대기</span>
                                                    )}
                                                </p>
                                                <p>{data.inquireTitle}</p>
                                                <p>{data.userName}</p>
                                                <p>{formatDate(data.createDateTime)}</p>
                                                {showDetails[data.id] && (
                                                    <div className={style.details}>
                                                        <p className={style.inquireContent}>문의 내용: {data.inquireContent}</p>
                                                        {data.inquireType === "Complete" ? (
                                                            <p className={style.answer}>답변 내용: {data.answer}</p>
                                                        ) : (
                                                            <div>
                                                                <CInputGroup
                                                                    onClick={(e) => {
                                                                        e.stopPropagation(); // 부모 요소의 클릭 이벤트 방지
                                                                    }}
                                                                >
                                                                    <CInputGroupText>답변 내용</CInputGroupText>
                                                                    <CFormInput
                                                                        placeholder="답변 내용을 입력해주세요"
                                                                        ref={(el) => (inputs.current[data.id] = el)}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); // 부모 요소의 클릭 이벤트 방지
                                                                        }}
                                                                    />
                                                                </CInputGroup>
                                                                <CButton
                                                                    onClick={(e) => {
                                                                        e.stopPropagation(); // 행 클릭 이벤트 방지
                                                                        answerInquiry(data.id);
                                                                    }}
                                                                    className="mt-2"
                                                                >
                                                                    답변
                                                                </CButton>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    ) : (
                                        <div className={style.emptyMessage}>
                                            <p>해당 카테고리의 문의가 없습니다.</p>
                                        </div>
                                    )}
                                </div>
                                
                                {totalPages > 0 && (
                                    <div className={style.pagination}>
                                        <button 
                                            className={style.pageButton} 
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            이전
                                        </button>
                                        
                                        {getPageNumbers().map(pageNumber => (
                                            <button
                                                key={pageNumber}
                                                className={`${style.pageButton} ${currentPage === pageNumber ? style.active : ''}`}
                                                onClick={() => handlePageChange(pageNumber)}
                                            >
                                                {pageNumber}
                                            </button>
                                        ))}
                                        
                                        <button 
                                            className={style.pageButton} 
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            다음
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorInquireList;